import styled, { css } from "styled-components";

import { Blank, H2, IBlankProps, IconButton, MainTabContainer, TabBlock, TabContainer } from "@evergis/ui";

const containerMixin = css`
  width: 100%;
  position: sticky;
  top: 0;
  left: 0;
  z-index: 5;
  min-width: 48rem;
`;

export const Container = styled.div<IBlankProps>`
  ${containerMixin}
`;

export const ShadowContainer = styled(Blank)`
  ${containerMixin}
`;

const DarkHeaderBlockMixin = css`
  :after {
    content: "";
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-color: ${({ theme }) => theme.elementsArea.cardOverlayColor};
  }
`;

export const HeaderBlock = styled.div<{ $isDark?: boolean; dialogStyled?: boolean }>`
  position: sticky;
  top: 0;
  display: flex;
  flex-direction: column;
  height: ${({ dialogStyled }) => (dialogStyled ? "8.25rem" : "8rem")};
  flex: 0 0 auto;
  justify-content: center;
  align-items: center;
  z-index: 5;
  background: ${({ theme }) => theme.palette.background};
  padding: ${({ dialogStyled }) => (dialogStyled ? "18px 0" : "0 1.5rem")};
  box-sizing: border-box;
  overflow-x: hidden;
  padding-bottom: 0;

  > * {
    z-index: 1;
  }

  ${({ $isDark }) => $isDark && DarkHeaderBlockMixin}
`;

export const DialogHeader = styled(H2)`
  position: absolute;
  left: 1.5rem;
  top: 16px;
  margin: 0;
`;

export const CloseButton = styled(IconButton)`
  z-index: 3;
  position: absolute;
  right: 2rem;
  top: 14px;
`;

export const TopContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 3.5rem;
`;

export const TabsContainer = styled.div`
  justify-self: center;
  margin-top: -18px;

  ${MainTabContainer}, ${TabContainer}, ${TabBlock} {
    background: transparent;
  }
`;

export const RightButtonsContainer = styled.div`
  display: flex;
  margin-top: 1rem;
  position: absolute;
  right: 1.5rem;
`;

export const LocalizationMenuContainer = styled.div`
  margin: 0.9rem 1rem 0 0;
`;
